import React, { useState, useEffect } from "react";
import axios from "axios";
import Logo from "./assets/images/Logo/Hazar-terra-leaf.png";
import Select from "react-select"; // Importation de react-select
import emailjs from "emailjs-com";


const SectionAbout = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    product: "",
    country: "",
    city: "",
    phone:"",
  });

  const [isWhatsApp, setIsWhatsApp] = useState(false); // État pour switcher entre email et WhatsApp
  const [transition, setTransition] = useState(false); // État pour gérer la transition
  const [countries, setCountries] = useState([]); // Liste des pays
  const [cities, setCities] = useState([]); // Liste des villes en fonction du pays
  const [loadingCountries, setLoadingCountries] = useState(true); // Loading state pour les pays
  const [loadingCities, setLoadingCities] = useState(false); // Loading state pour les villes

  // Récupérer la liste des pays
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://restcountries.com/v3.1/all");
        const countryOptions = response.data.map((country) => ({
          value: country.cca2,
          label: country.name.common,
        }));
        setCountries(countryOptions);
        setLoadingCountries(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des pays:", error);
      }
    };

    fetchCountries();
  }, []);

  // Récupérer la liste des villes en fonction du pays sélectionné (utilisation de Geonames API)
  const fetchCities = async (countryCode) => {
    setLoadingCities(true);
    try {
      const response = await axios.get(`https://api.geonames.org/searchJSON`, {
        params: {
          country: countryCode,
          maxRows: 10,
          username: "axl09", // Remplace ceci par ton propre nom d'utilisateur Geonames
        },
      });
      const cityOptions = response.data.geonames.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCities(cityOptions);
      setLoadingCities(false);
    } catch (error) {
      console.error("Erreur lors de la récupération des villes:", error);
      setLoadingCities(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSwitch = () => {
    setTransition(true); // Active la transition
    setTimeout(() => {
      setIsWhatsApp(!isWhatsApp); // Change l’état après l’animation
      setTransition(false); // Désactive la transition
    }, 300); // Durée de l'animation en millisecondes
  };

  const handleCountryChange = (selectedOption) => {
    const selectedCountry = selectedOption ? selectedOption.value : "";
    const selectedCountryName = selectedOption ? selectedOption.label : "";
    setFormData({ ...formData, countryN: selectedCountryName, country: selectedCountry, city: "" });
    fetchCities(selectedCountry); // Appelle la fonction pour récupérer les villes
  };

  const handleCityChange = (selectedOption) => {
    setFormData({
      ...formData,
      city: selectedOption ? selectedOption.value : "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (isWhatsApp) {
      const whatsAppLink = `https://wa.me/212662117783?text=Nom:%20${encodeURIComponent(
        formData.name
      )}%0AE-mail:%20${encodeURIComponent(
        formData.email
      )}%0AProduits:%20${encodeURIComponent(
        formData.product
      )}%0ADétails%20de%20la%20demande:%20${encodeURIComponent(
        formData.message
      )}%0APays:%20${encodeURIComponent(
        formData.countryN
      )}%0AVille:%20${encodeURIComponent(formData.city)}`;
      window.open(whatsAppLink, "_blank");
    } else {
      // Construction du contenu HTML de l'email
      const emailContent = `
        <html>
          <body>
            <h1>Demande d'informations</h1>
            <p><strong>Nom:</strong> ${formData.name}</p>
            <p><strong>Email:</strong> ${formData.email}</p>
            <p><strong>Téléphone:</strong> ${formData.phone}</p>
            <p><strong>Produit:</strong> ${formData.product}</p>
            <p><strong>Détails de la demande:</strong> ${formData.message}</p>
            <p><strong>Pays:</strong> ${formData.countryN}</p>
            <p><strong>Ville:</strong> ${formData.city}</p>
          </body>
        </html>
      `;
  
      // Préparer l'email avec les données du formulaire
      const emailData = {
        to_email: "contact@hazar-terra.ma",  // Remplacez par votre adresse email
        subject: "Demande d'informations",
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        product: formData.product,
        message: formData.message,
        country: formData.countryN,
        city: formData.city,
        content: emailContent,
      };
  
      try {
        // Envoi de l'email via EmailJS API
        const response = await emailjs.send(
          "service_gdf0j3q",  // Remplacez par votre ID de service EmailJS
          "template_rscc195",  // Remplacez par votre ID de modèle EmailJS
          emailData,
          "Mt-FCyIjS00nNw_dU"  // Remplacez par votre clé publique API EmailJS
        );
  
        // Réponse si l'email est envoyé avec succès
        console.log("Email envoyé avec succès !", response);
        alert("Votre demande a été envoyée avec succès!");
      } catch (error) {
        // Gestion des erreurs si l'email n'est pas envoyé
        console.error("Erreur lors de l'envoi de l'email", error);
        alert("Une erreur est survenue lors de l'envoi, veuillez réessayer.");
      }
    }
  };
  

  return (
    <div id="about" className="py-12 px-4 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Section gauche: texte de présentation */}
        <div className="flex-1">
          <img
            src={Logo}
            alt="Logo"
            className="w-56 md:w-80 h-auto mx-auto mb-8"
          />
          <div className="flex flex-col items-start">
            <h2 className="text-xl font-normal text-gray-800 mb-4 border-b-2 border-b-[#69B578]">
              À propos de nous
            </h2>
            <p className="text-lg text-gray-700">
              Hazar Terra, votre partenaire de confiance pour l'exportation de
              produits frais et de haute qualité. Spécialisés dans les produits
              périssables, nous proposons une large gamme de fruits, de légumes
              soigneusement sélectionnés et de produits du terroir pour répondre
              aux exigences des marchés internationaux.
            </p>
          </div>
        </div>
        {/* Section droite: formulaire de contact */}
        <div className="w-full flex-1 bg-white p-6 rounded-lg shadow-lg">
  <div className="flex items-center justify-between mb-4">
    <h3 className="text-2xl text-gray-800">Contactez-nous</h3>
    {/* Bouton de switch */}
    <div className="flex items-center">
      <span className="text-sm text-gray-600 mr-2">
        {isWhatsApp ? "WhatsApp" : "Email"}
      </span>
      <button
        onClick={handleSwitch}
        className={`w-12 h-6 rounded-full flex items-center ${
          isWhatsApp ? "bg-green-500" : "bg-gray-300"
        }`}
      >
        <div
          className={`w-5 h-5 bg-white rounded-full transform ${
            isWhatsApp ? "translate-x-6" : "translate-x-0"
          } transition-transform duration-200`}
        />
      </button>
    </div>
  </div>

  <form onSubmit={handleSubmit}>
    {/* Champ Nom */}
    <div
      className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
    >
      <label htmlFor="name" className="block text-sm font-medium text-gray-600">
        Nom
      </label>
      <input
        type="text"
        id="name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
        required
      />
    </div>

    {/* Champ Produits */}
    <div
      className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
    >
      <label htmlFor="product" className="block text-sm font-medium text-gray-600">
        Produits
      </label>
      <select
        id="product"
        name="product"
        value={formData.product}
        onChange={handleChange}
        className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
        required
      >
        <option value="">Sélectionner un produit</option>
        <option value="fruits">Fruits</option>
        <option value="legumes">Légumes</option>
        <option value="produits_terroir">Produits du terroir</option>
      </select>
    </div>

    {/* Champ Détails de la demande */}
    <div
      className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
    >
      <label htmlFor="message" className="block text-sm font-medium text-gray-600">
        Détails de la demande
      </label>
      <textarea
        id="message"
        name="message"
        value={formData.message}
        onChange={handleChange}
        className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
        required
      />
    </div>

    {/* Sélection du pays avec autocomplétion */}
    <div
      className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
    >
      <label htmlFor="country" className="block text-sm font-medium text-gray-600">
        Pays
      </label>
      <Select
        id="country"
        name="country"
        value={countries.find((country) => country.value === formData.country)}
        onChange={handleCountryChange}
        options={countries}
        isLoading={loadingCountries}
        placeholder="Sélectionner un pays"
        required
      />
    </div>

    {/* Sélection de la ville avec autocomplétion */}
    {formData.country && (
      <div
        className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
      >
        <label htmlFor="city" className="block text-sm font-medium text-gray-600">
          Ville
        </label>
        <Select
          id="city"
          name="city"
          value={cities.find((city) => city.value === formData.city)}
          onChange={handleCityChange}
          options={cities}
          isLoading={loadingCities}
          placeholder="Sélectionner une ville ou tapez une ville"
          required
          isClearable
          onInputChange={(inputValue) => {
            if (!cities.some((city) => city.value === inputValue)) {
              setCities([{ value: inputValue, label: inputValue }]);
            }
          }}
        />
      </div>
    )}

    {/* Champ Email (uniquement pour WhatsApp) */}
    {isWhatsApp && (
      <div
        className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
      >
        <label htmlFor="email" className="block text-sm font-medium text-gray-600">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
          required
        />
      </div>
    )}

    {/* Champ Numéro de téléphone (uniquement pour Email) */}
    {!isWhatsApp && (
      <div
        className={`mb-4 ${transition ? "opacity-50" : "opacity-100"} transition-opacity duration-300`}
      >
        <label htmlFor="phone" className="block text-sm font-medium text-gray-600">
          Téléphone
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
          required
        />
         <label htmlFor="email" className="block text-sm font-medium text-gray-600">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="mt-2 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#69B578]"
          required
        />
      </div>
    )}

    <button
      type="submit"
      className="w-full py-2 px-4 bg-[#69B578] text-white rounded-md hover:bg-[#3A7D44] focus:outline-none focus:bg-[#D0DB97] transition-colors ease-in-out duration-200"
    >
      {isWhatsApp ? "Envoyer via WhatsApp" : "Envoyer par Email"}
    </button>
  </form>
</div>

      </div>
    </div>
  );
};

export default SectionAbout;